import ListingStates from '../../../../constants/listings/ListingStates'

const TabStates = [
  {
    title: 'Open',
    tabs: [
      {
        id: 'active-all',
        humanReadableName: 'All',
        states: null
      }
    ]
  },
  {
    title: 'Closed',
    tabs: [
      {
        id: 'inactive-all',
        humanReadableName: 'All',
        states: null
      },
      {
        id: 'inactive-pending',
        humanReadableName: 'Pending',
        states: ListingStates.PENDING.id
      },
      {
        id: 'inactive-unpaid',
        humanReadableName: 'Unpaid',
        states: ListingStates.UNPAID.id
      },
      {
        id: 'inactive-sold',
        humanReadableName: 'Sold',
        states: ListingStates.SOLD.id
      },
      {
        id: 'inactive-expired',
        humanReadableName: 'Expired',
        states: ListingStates.EXPIRED.id
      },
      {
        id: 'inactive-delisted',
        humanReadableName: 'Delisted',
        states: ListingStates.DELISTED.id
      },
      {
        id: 'inactive-purged',
        humanReadableName: 'Recycled',
        states: ListingStates.PURGED.id
      }
    ]
  }
]

export default TabStates
